import {BaseModel} from '../base.model';
import {JsonProperty} from '../json-map.util';
import {ProblemModel} from '../problem/problem.model';

class TopicModel extends BaseModel {

  slug: string = undefined as any;
  displayName: string = undefined as any;
  subject: string = undefined as any;
  tier1: string = undefined as any;
  tier2: string = undefined as any;
  tier3: string = undefined as any;
  tier4: string = undefined as any;

  strategyName: string = undefined as any;
  strategyDescription: string = undefined as any;

  @JsonProperty({ clazz: ProblemModel })
  problems: ProblemModel[] = [];

  parse(json: Object) {
    if (json) {
      super.parse(json);
    }

    return this;
  }
}


export { TopicModel };
